import {
  buildSessionBaselineFromHistory,
  findSessionBaselineTrimUserMessageId,
  sessionBaselineDiffersFromTurnBundle,
  sessionBaselineHasRestorableSnapshots,
  type HistoryMessageWithSnapshotBundle,
  type SessionSnapshotBundle,
  type SessionSnapshotBundleInput,
} from "~shared/agenticChat/sessionSnapshotBaseline";

export type AgenticChatSnapshotBundle = SessionSnapshotBundleInput;

export function hasRestorableAgenticSnapshotBundle(
  bundle: AgenticChatSnapshotBundle | null | undefined,
): boolean {
  return sessionBaselineHasRestorableSnapshots(bundle);
}

type MessageWithSnapshot = HistoryMessageWithSnapshotBundle;

/** Earliest per-entity snapshots from assistant messages (shared with server session baseline). */
export function buildSessionBaselineFromMessages(
  messages: MessageWithSnapshot[],
): SessionSnapshotBundle | null {
  return buildSessionBaselineFromHistory(messages);
}

export { findSessionBaselineTrimUserMessageId, sessionBaselineDiffersFromTurnBundle };
